import { L10nConfig } from 'angular-l10n';
import { SamplicityProviderType } from '../core/translation-service';

export const l10nLangConfig: L10nConfig = {
  format: 'language-region',
  providers: [
    {
      name: 'app',
      asset: {
        type: SamplicityProviderType.Static,
        prefix: './assets/locale-'
      }
    },
    {
      name: 'micro',
      asset: {
        type: SamplicityProviderType.LocalizationMicroService,
        moduleId: '2C37DF17-7691-4457-92E1-1748CED477EB'
      }
    }
  ],
  cache: true,
  keySeparator: '.',
  defaultLocale: { language: 'en', currency: 'USD', timeZone: 'America/New_York'},
  schema: [
    { locale: { language: 'en', currency: 'USD', timeZone: 'America/New_York' } }
  ]
};
